$(function () {
	$('.product-list.section .product-list__content').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		// asNavFor: `#${productGalleryFor}`,
		dots: false,
		arrows: true,
		centerMode: false,
		focusOnSelect: true,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 380,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					dots: true,
				}
			},
		]
	});
});